import { ImageDialog } from '@/components/ImageDialog';
import { safeHtml } from '@/utils/safeHtml';
import type React from 'react';
import styles from './index.module.scss';

export type ExplanationProps = {
  explanationContent: string;
  explanationAttachmentImageUrl?: string | null;
};

export const Explanation: React.FC<ExplanationProps> = ({
  explanationContent,
  explanationAttachmentImageUrl,
}) => {
  return (
    <div className={styles.explanationArea} id="explanation">
      <div className={styles.explanationLabel}>解説</div>
      <p
        className={styles.explanationContent}
        // biome-ignore lint/security/noDangerouslySetInnerHtml: サニタイズ済みのHTMLを表示するため
        dangerouslySetInnerHTML={{
          __html: safeHtml(explanationContent),
        }}
      />
      {explanationAttachmentImageUrl && (
        <div className={styles.explanationImg}>
          <ImageDialog imageUrl={explanationAttachmentImageUrl} />
        </div>
      )}
    </div>
  );
};
